//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  BoundingBoxDTO,
  IntelligentProductTaggingLinkRequestV1,
  IntelligentProductTaggingLinkRequestV2,
} from '@apis/intelligent-product-tagging/intelligentProductTaggingApiModel';
import { serializedGatewayFetch } from '@utils/sessionFetch';
import { ISerializedResponse } from '@utils/types/SerializedResponse';

// TODO: PD-301920 - Cleanup the linkProductToBoundingBoxV1 method and version logic once IPTv2 GAed
const intelligentProductTaggingFetch = (
  endpoint: string,
  version: 'v1' | 'v2',
  init?: RequestInit,
): Promise<ISerializedResponse> => {
  return serializedGatewayFetch(
    'ipt_gateway',
    `/api/${version}/ipt${endpoint}`,
    init,
  );
};

/**
 * Records that a client linked a product to a bounding box (v1)
 *
 * POST /api/v1/ipt/link
 */
export const linkProductToBoundingBoxV1 = async (
  req: IntelligentProductTaggingLinkRequestV1,
  init?: RequestInit,
): Promise<BoundingBoxDTO> => {
  const res = await intelligentProductTaggingFetch(`/link`, 'v1', {
    ...(init ?? {}),
    body: JSON.stringify(req),
    method: 'POST',
  });

  return res.json<BoundingBoxDTO>();
};

/**
 * Records that a client linked a product to a bounding box (v2)
 *
 * POST /api/v2/ipt/link
 */
export const linkProductToBoundingBoxV2 = async (
  req: IntelligentProductTaggingLinkRequestV2,
  init?: RequestInit,
): Promise<void> => {
  await intelligentProductTaggingFetch(`/link`, 'v2', {
    ...(init ?? {}),
    body: JSON.stringify(req),
    method: 'POST',
  });
};
